import { Grid, Button, TextField, FormControl } from '@mui/material';
import { maxPortalsAllowed } from '../../../settings/appConfig';
import GenericSelectInput from './UI/GenericSelectInput';
import { Add } from "@mui/icons-material";
import PortalType from '../../../Models/Locations/portalType';
import GenericInput from './UI/GenericInput';
export default function Portals({
  formik,
  portalTypes,
  isCustodian
}: {
  formik: any;
  isCustodian: boolean;
  portalTypes: PortalType[];
}) {
  const onAddNewPortal = async () => {
    const newItems = [
      ...formik.values.portalUrls,
      { portalUrl: '', portalTypeId: null },
    ];
    formik.setFieldValue('portalUrls', newItems);
  };
  return (
    <>
      {formik?.values?.portalUrls?.length > 0 &&
        formik?.values?.portalUrls?.map((item: any, index: number) => (
          <Grid container key={index} alignItems={'center'} my={1}>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`portalUrls.${index}.portalUrl`}
                label="Portal Url"
                placeholder="Portal Url"
                maxLength={150}
                inputMode="url"
                value={item.portalUrl}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    `portalUrls.${index}.portalUrl`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik.touched.portalUrls &&
                    formik.touched.portalUrls[index] &&
                    formik.touched.portalUrls[index]['portalUrl'] &&
                    formik.errors.portalUrls &&
                    formik.errors.portalUrls[index] &&
                    formik.errors.portalUrls[index]['portalUrl']
                    ? formik.errors.portalUrls[index]['portalUrl']
                    : ''
                }
                hasError={
                  formik.touched.portalUrls &&
                    formik.touched.portalUrls[index] &&
                    formik.touched.portalUrls[index]['portalUrl'] &&
                    formik.errors.portalUrls &&
                    formik.errors.portalUrls[index] &&
                    formik.errors.portalUrls[index]['portalUrl']
                    ? true
                    : false
                }
                onBlur={() => {
                  formik.setFieldTouched(`portalUrls.${index}.portalUrl`, true);
                }}
              />
            </Grid>
            {isCustodian &&
              <><Grid item xs={4} px={2}>
                <GenericSelectInput
                  name={`portalUrls.${index}.portalTypeId`}
                  label="Type"
                  value={item.portalTypeId}
                  onChange={(value: string) => {
                    formik.setFieldValue(`portalUrls.${index}.portalTypeId`, value);
                  }}
                  errorMsg={formik.touched['portalUrls'] &&
                    formik.touched['portalUrls'][index] &&
                    formik.touched['portalUrls'][index]['portalTypeId'] &&
                    formik.errors['portalUrls'] &&
                    formik.errors['portalUrls'][index] &&
                    formik.errors['portalUrls'][index]['portalTypeId']
                    ? formik.errors['portalUrls'][index]['portalTypeId']
                    : ''}
                  hasError={formik.touched['portalUrls'] &&
                    formik.touched['portalUrls'][index] &&
                    formik.touched['portalUrls'][index]['portalTypeId'] &&
                    formik.errors['portalUrls'] &&
                    formik.errors['portalUrls'][index] &&
                    formik.errors['portalUrls'][index]['portalTypeId']
                    ? true
                    : false}
                  onBlur={() => {
                    formik.setFieldTouched(`portalUrls[${index}].portalTypeId`, true);
                  }}
                  options={portalTypes} />
              </Grid><Grid item xs={4} px={2}>
                  <FormControl fullWidth>
                    <TextField
                      name="portalNotes"
                      label="Portal Notes"
                      rows={4}
                      variant="outlined"
                      value={item.portalNotes}
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          `portalUrls.${index}.portalNotes`,
                          e.target.value
                        );
                      }}
                      helperText={formik.touched.portalUrls &&
                        formik.touched.portalUrls[index] &&
                        formik.touched.portalUrls[index]['portalNotes'] &&
                        formik.errors.portalUrls &&
                        formik.errors.portalUrls[index] &&
                        formik.errors.portalUrls[index]['portalNotes']
                        ? formik.errors.portalUrls[index]['portalNotes']
                        : ''}
                      error={formik.touched.portalUrls &&
                        formik.touched.portalUrls[index] &&
                        formik.touched.portalUrls[index]['portalNotes'] &&
                        formik.errors.portalUrls &&
                        formik.errors.portalUrls[index] &&
                        formik.errors.portalUrls[index]['portalNotes']
                        ? true
                        : false}
                      onBlur={() => {
                        formik.setFieldTouched(`portalUrls.${index}.portalNotes`, true);
                      }} />
                  </FormControl>

                </Grid></>}

            <Grid item xs={3} px={1}>
              {formik.values.portalUrls.length > 1 && (
                <Button
                  type="button"
                  onClick={() => {
                    const newItems = [...formik.values.portalUrls];
                    newItems.splice(index, 1);
                    formik.setFieldValue('portalUrls', [...newItems]);
                  }}
                >
                  Remove
                </Button>
              )}

              {index === formik.values.portalUrls.length - 1 &&
                formik.values.portalUrls.length < maxPortalsAllowed && (
                  <Button
                    type="button"
                    onClick={onAddNewPortal}
                    startIcon={<Add />}
                  >
                    Add Other Portal
                  </Button>
                )}
            </Grid>
          </Grid>
        ))}

    </>
  );
}
